import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Spinner } from '@/components/ui/spinner';
import { FileEdit } from 'lucide-react';


interface NotesSectionProps {
  notes: {
    before: string;
    during: string;
    after: string;
    conversation: string;
  };
  onChange: (notes: {
    before: string;
    during: string;
    after: string;
    conversation: string;
  }) => void;
  autoSaveStatus?: 'idle' | 'saving' | 'saved';
  disabled?: boolean;
}



export const NotesSection: React.FC<NotesSectionProps> = ({
  notes,
  onChange,
  autoSaveStatus = 'idle',
  disabled = false,
}) => {
  const [localNotes, setLocalNotes] = useState('');

  useEffect(() => {
    // unifiedフィールドがある場合はそれを使用、なければ既存データから生成
    if ((notes as any).unified) {
      setLocalNotes((notes as any).unified);
    } else {
      // 既存データから統合されたテキストを生成
      const sections = [];
      if (notes.before) sections.push(`【施術前】\n${notes.before}`);
      if (notes.during) sections.push(`【施術中】\n${notes.during}`);
      if (notes.after) sections.push(`【施術後】\n${notes.after}`);
      if (notes.conversation) sections.push(`【会話メモ】\n${notes.conversation}`);
      
      setLocalNotes(sections.join('\n\n'));
    }
  }, [notes]);

  const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setLocalNotes(newValue);
    
    // 既存構造を保持しつつ、新フィールドに保存
    onChange({
      ...notes,
      unified: newValue,
    } as any);
  };

  return (
    <Card className="bg-muted/50 min-h-[200px] transition-all duration-300 hover:bg-muted">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <FileEdit className="h-5 w-5" />
            施術メモ
          </CardTitle>
          {autoSaveStatus === 'saving' && (
            <div className="flex items-center gap-1.5">
              <Spinner className="h-3.5 w-3.5" />
              <span className="text-xs text-muted-foreground">保存中</span>
            </div>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <Textarea
          value={localNotes}
          onChange={handleNoteChange}
          placeholder="施術に関するメモを自由に記入してください。&#10;例：お客様の状態、施術内容、会話の内容、次回への申し送りなど..."
          disabled={disabled}
          className="min-h-[200px] bg-background text-base leading-relaxed resize-y hover:bg-accent/50 disabled:hover:bg-background"
          rows={8}
        />
      </CardContent>
    </Card>
  );
};